/* @flow */

import Immutable from 'immutable';
import { ViewConstants } from '../constants/view_constants';
import { SharedConstants } from '../constants/shared_constants';

const viewInitialState = Immutable.Map({
  activeViewId: 'default',
  views: Immutable.Map(),
  menuVisible: false,
});

function viewReducer(state: Immutable.Map = viewInitialState, action: Object): Immutable.Map {
  switch (action.type) {
    case SharedConstants.SHARED_PURGE: {
      return viewInitialState;
    }

    case ViewConstants.VIEW_SET_ACTIVE: {
      return state.set('activeViewId', action.viewId);
    }
    case ViewConstants.VIEW_LOAD: {
      return state.setIn(['views', action.viewId], Immutable.fromJS(action.viewSettings));
    }
    case ViewConstants.VIEW_TOGGLE_MENU: {
      return state.set('menuVisible', !(state.get('menuVisible')));
    }
  }
  return state;
}

export {
  viewInitialState,
  viewReducer
};
